const requireModule = require.context('.', false, /\.route\.js$/)

export default requireModule.keys().map(filename => requireModule(filename).default || requireModule(filename))